<div class="toolbar-break"></div>
<div class="container px-3">
  <div class="hero-title text-center my-5">
    <h1>Clear Water Essentials</h1>
    <p class="h4 mt-3">Shop Our Best Selling Pool &amp; Spa Water Clarity Products</p>
  </div>
</div>

<section class="section-band pool-band">
  <div class="container px-3">
    <div class="section-header text-center">
      <h2>Pool Water Clarity</h2>
      <div class="header-accent"></div>
    </div>
    @if (poolLoading) {
      <ngx-skeleton-loader count="4"
        [theme]="{ width: '23%', height: '350px', 'margin-right': '10px' }">
      </ngx-skeleton-loader>
    } @else {
      <div class="row gy-1 gy-lg-5">
        @for (product of poolProducts; track product) {
          <div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex justify-content-evenly">
            <app-product-card [product]="product"></app-product-card>
          </div>
        }
      </div>
    }
    <div class="d-flex justify-content-center mt-5">
      <button class="primary" (click)="navigate('pool-care')">
        Shop All Pool Products
      </button>
    </div>
  </div>
</section>

<div class="clearfix">
  <img class="wave-right" src="assets/images/pink-curve-right.png" alt="pink wave pointing right">
</div>

<section class="section-band spa-band">
  <div class="container px-3">
    <div class="section-header text-center">
      <h2>Hot Tub &amp; Spa Water Clarity</h2>
      <div class="header-accent"></div>
    </div>
    @if (spaLoading) {
      <ngx-skeleton-loader count="4"
        [theme]="{ width: '23%', height: '350px', 'margin-right': '10px' }">
      </ngx-skeleton-loader>
    } @else {
      <div class="row gy-1 gy-lg-5">
        @for (product of spaProducts; track product) {
          <div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex justify-content-evenly">
            <app-product-card [product]="product"></app-product-card>
          </div>
        }
      </div>
    }
    <div class="d-flex justify-content-center mt-5">
      <button class="primary" (click)="navigate('hot-tub-care')">
        Shop All Hot Tub Products
      </button>
    </div>
  </div>
</section>

<div class="clearfix">
  <img class="wave-left" src="assets/images/pink-curve-left.png" alt="pink wave pointing left">
</div>

<section class="section-band">
  <div class="container px-3">
    <h2 class="mb-3 text-center">New to Water Care?</h2>
    <p class="mb-4 text-center">Learn the basics before you buy with these guides from our blog:</p>
    <div class="row">
      @for (blog of blogs; track blog) {
        <div class="col-12 col-md-6 col-lg-3 d-flex justify-content-center d-lg-block">
          <app-blog-card [blogPost]="blog"></app-blog-card>
        </div>
      }
    </div>
  </div>
</section>

<section class="seo-copy">
  <div class="container px-3">
    <h2 class="h5">Your Guide to Crystal Clear Pool &amp; Hot Tub Water</h2>
    <div class="row">
      <div class="col-12 col-lg-6">
        <h3 class="h6">What causes cloudy pool water?</h3>
        <p>Cloudy or hazy pool water is usually caused by low sanitizer levels, poor filtration, or a buildup of contaminants like algae, phosphates, and debris. The fastest fix is to test your water, balance your chemistry, and treat with a quality pool shock like BioGuard Smart Shock. For ongoing clarity, maintain a steady free chlorine residual with slow-dissolving chlorinating tablets such as BioGuard SilkGuard Complete 3 Inch Chlorinating Tablets.</p>
        <h3 class="h6">How do I keep my pool water clear all season?</h3>
        <p>Consistent sanitization is the key to clear pool water. Run your pump and filter daily, test chlorine and pH weekly, shock after heavy use or rain, and keep phosphates in check. Shop our full range of <a routerLink="/pool-care">pool care supplies</a> including chlorine, shock, algaecides, clarifiers, and test strips.</p>
      </div>
      <div class="col-12 col-lg-6">
        <h3 class="h6">Why is my hot tub water cloudy or foamy?</h3>
        <p>Cloudy or foamy hot tub water is commonly caused by low sanitizer, body oils, lotions, and detergent residue. A weekly dose of chlorinating concentrate like SpaGuard Chlorinating Concentrate keeps spa water sanitized, while Frog &#64;ease SmartChlor Cartridges and the Spa Frog Serene Cartridge Kit provide continuous, low-maintenance sanitization between soaks.</p>
        <h3 class="h6">What do I need to start treating my hot tub?</h3>
        <p>New hot tub owners can start simple with an all-in-one kit like the Amerse Chlorine Hot Tub Starter Kit, which includes everything you need to sanitize, shock, and balance your spa water. Browse all of our <a routerLink="/hot-tub-care">hot tub care supplies</a> for bromine, chlorine, water balancers, and filter cartridges.</p>
      </div>
    </div>
  </div>
</section>
